import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../customcss.css'
import { product } from "../data";
import '../customcss.css'
import { CubeIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";



export default function Product() {
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
    return (
        <section id="product" className="slide-container slideshow 	">
          <div className="slide-container slideshow">
          <div className="text-center mb-20">
          <CubeIcon className="w-10 inline-block mb-4" />
          <Link to="/ProductDesign">
          <h1 className="sm:text-4xl text-3xl font-medium title-font text-white mb-2">
            Product Design 
          </h1>
          </Link>
        </div>
                <Slider {...settings}>
                    {product.map((product)=> (
                    <div className="card">
                      <h1 className="center font-bold">{product.title}</h1>
                        <a href ="">
                        <img src={product.src}/>
                        <p className="center">{product.description}</p>
                        </a>
                    </div>
                    ))}
                </Slider>
          </div>
      </section>
    )
}

